import { Button, Col, Spinner2 } from 'components';
import { Api, sports, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Athletes } from './';

const Wrapper = styled.div`
  width: 100%;
  margin-top: 34px;
  display: flex;
  justify-content: center;

  @media (max-width: 1024px) {
    width: 100vw;
    margin-top: 28px;
  }

  .content-area {
    width: 1140px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 1024px) {
      width: 100vw;
    }

    .button-wrapper {
      width: 1002px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 54px;

      @media (max-width: 1024px) {
        margin-bottom: 35px;
        padding: 0 13px;
        width: auto;
      }

      button {
        margin-top: 22px;

        @media (max-width: 1024px) {
          width: 124px !important;
          height: 30px !important;
          margin-top: 8px;
        }

        p {
          @media (max-width: 1024px) {
            font-size: 16px;
          }
        }
      }
    }
  }
`;

const selectedSports = [
  'soccer',
  'cricket',
  'basketball',
  'hockey',
  'tennis',
  'volleyball',
  'boxing',
  'baseball',
  'americanFootball',
  'rugby',
  'mma',
  'kickboxing'
];

const AthletePicker = () => {
  const [selected, setSelected] = useState(sports[0].value),
    [data, setData] = useState([]),
    [loading, setLoading] = useState(false),
    { t } = useTranslation(),
    isMobile = useSelector((state) => state.appState.isMobile);

  useEffect(() => {
    handleChange(selected);
  }, []);

  async function handleChange(sport) {
    setSelected(sport);
    setLoading(true);

    const res = await Api.post('/website/getAthletes', { sport });
    if (!res) return setLoading(false);

    setData(res);
    setLoading(false);
  }

  async function loadMore() {
    setLoading(true);
    const res = await Api.post(
      '/website/getAthletes',
      { sport: selected, skip: data.length },
      'ourAthletesLoadMore'
    );
    if (!res) return setLoading(false);

    setLoading(false);

    setData([...data, ...res]);
  }

  return (
    <Wrapper>
      <div className="content-area">
        <div className="button-wrapper">
          {selectedSports.map((x, i) => {
            const foundSport = sports.find((y) => y.name === x);
            if (!foundSport) return null;

            return (
              <Button
                key={i}
                website
                col={x === selected ? theme.SECONDARY : '#E5E5E5'}
                wid="220px"
                marg="0 0"
                text={t(`sports.${foundSport.name}`)}
                onClick={() => handleChange(foundSport.name)}
              />
            );
          })}
        </div>

        {!!data?.length && (
          <Col minHt={isMobile ? '12px' : '296px'} centerAll>
            <Athletes data={data} />

            {!!(data.length && data.length < 30 && data.length % 5 === 0) && !loading && (
              <Button
                website
                wid="180px"
                text="Load More"
                action="ourAthletesLoadMore"
                onClick={loadMore}
              />
            )}
          </Col>
        )}

        {loading && (
          <Col wid="100%" noFlex>
            <Spinner2 />
          </Col>
        )}
      </div>
    </Wrapper>
  );
};

export default AthletePicker;
